import styled from 'styled-components';
import { propStyling } from '../../shared/propStyling/propStyling';
export const Box = styled.div.withConfig({
  displayName: "Box"
})(["", ""], propStyling);
//# sourceMappingURL=Box.js.map